import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { getPlanSaveLabel } from '../../shared/plan-helpers';
import styles from './SubscriptionCardV4.css';

const cx = classnames.bind(styles);

function renderSubtitle(subscriptionData) {
    const weeks = subscriptionData.billingPeriod?.value;

    if (subscriptionData.trial) {
        return (
            <>
                {subscriptionData.trial.price}
                {' now, then '}
                {subscriptionData.price}
                {` every ${weeks} weeks`}
            </>
        );
    }

    return (
        <>
            {subscriptionData.price}
            {` every ${weeks} weeks`}
        </>
    );
}

function SubscriptionCardV4({ className = '', subscriptionData, selectedSubscriptionData, selectSubscription, isExpired = false, name = 'subscription-plan' }) {
    const isActive = subscriptionData.plan === selectedSubscriptionData.plan;
    const oldPrice = subscriptionData.displayOldPrice ?? subscriptionData.price;
    const newPrice = subscriptionData.trial?.price ?? subscriptionData.price;
    const hasOldPrice = !isExpired && oldPrice !== newPrice;
    const saveLabel = hasOldPrice && !subscriptionData.isDiscountBadgeHidden ? getPlanSaveLabel(subscriptionData) : null;

    return (
        <label className={cx('root', className, { active: isActive, withOldPrice: hasOldPrice })}>
            <input
                type='radio'
                name={name}
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {subscriptionData.isPopular && (
                <div className={styles.popularBanner}>
                    <Icon name='starFilled' className={styles.starIcon} />
                    Best offer
                </div>
            )}
            <div className={styles.content}>
                <span className={styles.radio}>
                    <span className={styles.radioDot} />
                </span>
                <div className={styles.planInfo}>
                    <p className={styles.name}>{subscriptionData.membershipName ?? subscriptionData.name}</p>
                    <p className={styles.subtitle}>{renderSubtitle(subscriptionData)}</p>
                </div>
                <div className={styles.priceInfo}>
                    {hasOldPrice && <p className={styles.oldPrice}>{oldPrice}</p>}
                    <p className={cx('newPrice', { expired: isExpired })}>{newPrice}</p>
                    {Boolean(saveLabel) && <span className={styles.saveBadge}>{`SAVE ${saveLabel}`}</span>}
                </div>
            </div>
        </label>
    );
}

SubscriptionCardV4.propTypes = {
    className: PropTypes.string,
    subscriptionData: PropTypes.object.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isExpired: PropTypes.bool,
    name: PropTypes.string
};

export {
    SubscriptionCardV4
};
